import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useOnboard from '../hooks/useOnboard'
import { skipsOnboarding } from '../utilities/onboardDetour'
import Layout from './Layout'

export default function AppLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const onboard = useOnboard()

  // Only the app shell sends an unstarted account to onboarding. The shared-link
  // routes — access/:serviceName, invite/:token — sit outside it on purpose:
  // someone opening a link to another org's service came for that service.
  //
  // Carry where they were aimed so the wizard can put them back there: accepting
  // an org invite lands on /org/members, and a mailed link lands anywhere in the
  // shell. Never the wizard itself — this fires again whenever `onboard` flips back
  // on, and it can flip while the user is inside the wizard (switching orgs from
  // the header re-scopes the network and node stores). Then the current step *is*
  // the location, so keep the return-to it is already carrying instead of pushing a
  // second welcome entry that has none.
  // ⚠⚠ THE MONEY ROUTES RENDER EVEN ON AN UNSTARTED ACCOUNT (app#242). A customer who has just
  // paid still has no nodes, so `onboard` is true at exactly the moment they come back from
  // Stripe — and they were being redirected off the confirmation into the wizard. See
  // `skipsOnboarding` for why this is not keyed on the `?status=` query.
  useEffect(() => {
    if (!onboard) return
    if (skipsOnboarding(location.pathname)) return
    const detour = !location.pathname.startsWith('/onboard')
    navigate(
      '/onboard/welcome',
      detour ? { state: { from: location } } : { state: location.state, replace: true }
    )
    // ⚠⚠ `location.pathname` IS DELIBERATELY NOT A DEPENDENCY, and adding it breaks Exit. This
    // effect fires on `onboard` alone, which is what lets the wizard's Exit work at all:
    // `useOnboardFrom` falls back to `/` when there is no return-to, `/` is not exempt, and an
    // effect that re-ran on every path change would send the user straight back to the wizard —
    // turning Exit into a loop. The early return above therefore covers the case it is for,
    // landing ON an exempt route, and changes nothing about navigation afterwards.
  }, [onboard])

  return <Layout />
}
